import { render, staticRenderFns } from "./RegistrarCidadao.vue?vue&type=template&id=5d89c4f4&"
import script from "./RegistrarCidadao.vue?vue&type=script&lang=js&"
export * from "./RegistrarCidadao.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarCidadao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports